/**
 * Vendored from lightvue@1.5.1/utils
 * Only DomHandler and ConnectedOverlayScrollHandler, the two classes used in this project.
 */

let zIndex = 0

export class DomHandler {
  static generateZIndex() {
    return ++zIndex
  }

  static getCurrentZIndex() {
    return zIndex
  }

  static addClass(el, className) {
    if (el.classList) el.classList.add(className)
    else el.className += ' ' + className
  }

  static removeClass(el, className) {
    if (el.classList) el.classList.remove(className)
    else el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ')
  }

  static getOffset(el) {
    const rect = el.getBoundingClientRect()
    return {
      top: rect.top + (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0),
      left: rect.left + (window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0),
    }
  }

  static getOuterWidth(el, margin) {
    let width = el.offsetWidth
    if (margin) {
      const style = getComputedStyle(el)
      width += parseFloat(style.marginLeft) + parseFloat(style.marginRight)
    }
    return width
  }

  static getOuterHeight(el, margin) {
    let height = el.offsetHeight
    if (margin) {
      const style = getComputedStyle(el)
      height += parseFloat(style.marginTop) + parseFloat(style.marginBottom)
    }
    return height
  }

  static getViewport() {
    const w = window
    const d = document
    const e = d.documentElement
    const g = d.getElementsByTagName('body')[0]
    return {
      width: w.innerWidth || e.clientWidth || g.clientWidth,
      height: w.innerHeight || e.clientHeight || g.clientHeight,
    }
  }

  static getWindowScrollTop() {
    const doc = document.documentElement
    return (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0)
  }

  static absolutePosition(el, target) {
    const elDimensions = el.offsetParent
      ? { width: el.offsetWidth, height: el.offsetHeight }
      : this.getHiddenElementDimensions(el)
    const elHeight = elDimensions.height
    const elWidth = elDimensions.width
    const targetHeight = target.offsetHeight
    const targetOffset = target.getBoundingClientRect()
    const viewport = this.getViewport()
    const windowScrollTop = this.getWindowScrollTop()

    let top, left

    if (targetOffset.top + targetHeight + elHeight > viewport.height) {
      top = targetOffset.top + windowScrollTop - elHeight
      if (top < 0) top = windowScrollTop
    } else {
      top = targetHeight + targetOffset.top + windowScrollTop
    }

    if (targetOffset.left + elWidth > viewport.width) {
      left = Math.max(0, targetOffset.left + DomHandler.getOuterWidth(target) - elWidth)
    } else {
      left = targetOffset.left
    }

    el.style.top = top + 'px'
    el.style.left = left + 'px'
  }

  static getHiddenElementDimensions(el) {
    const cloned = el.cloneNode(true)
    cloned.style.visibility = 'hidden'
    cloned.style.display = 'block'
    cloned.style.position = 'absolute'
    document.body.appendChild(cloned)
    const dims = { width: cloned.offsetWidth, height: cloned.offsetHeight }
    document.body.removeChild(cloned)
    return dims
  }

  static getScrollableParents(el) {
    const parents = []
    const overflowRegex = /(auto|scroll)/

    const isScrollable = (node) => {
      const cs = getComputedStyle(node)
      return overflowRegex.test(cs.overflow + cs.overflowX + cs.overflowY)
    }

    let parent = el.parentNode
    while (parent && parent !== document) {
      if (isScrollable(parent)) parents.push(parent)
      parent = parent.parentNode
    }
    parents.push(window)
    return parents
  }
}

export class ConnectedOverlayScrollHandler {
  constructor(element, listener = () => {}) {
    this.element = element
    this.listener = listener
  }

  bindScrollListener() {
    this.scrollableParents = DomHandler.getScrollableParents(this.element)
    for (let i = 0; i < this.scrollableParents.length; i++) {
      this.scrollableParents[i].addEventListener('scroll', this.listener)
    }
  }

  unbindScrollListener() {
    if (this.scrollableParents) {
      for (let i = 0; i < this.scrollableParents.length; i++) {
        this.scrollableParents[i].removeEventListener('scroll', this.listener)
      }
    }
  }

  destroy() {
    this.unbindScrollListener()
    this.element = null
    this.listener = null
    this.scrollableParents = null
  }
}
